import { Avatar } from 'antd';
import styled from 'styled-components';

export default styled(Avatar)`
	// Add your styles here
`;
